// ========== IMPORTS ==========
import React from 'react'
import ContentsBorderImage from '../../assets/images/ARISE WEBSITE_microsite-18.png';
import ArrowImage from '../../assets/images/ARISE WEBSITE_microsite-19.png';
import Right from '../../assets/images/Right.svg'
import '../../assets/styles/howitworks.css'

// ========== COMPONENT ==========
const HowItWorks = () => {

  // ========== RENDER ==========
  return (
    <section className='howitworks'>
      <div className='custom-padding'>
        <div className='howitworks-container pt-5'>
          <div className='howitworks-title-box mt-3 d-flex justify-content-center align-items-center'>
            <article className='font-bold text-start fs-1 mb-0'>How It Works</article>
          </div>
          <div className='howitworks-title-box-two d-flex justify-content-center align-items-center'>
            <div className='img-box w-100'>
              <img src={ContentsBorderImage} alt='Contents Border Image' />
            </div>
          </div>

          <div className='howitworks-title-box mt-2 d-flex justify-content-center align-items-center'>
            <article className='font-medium text-start fs-5 mb-0 txt-red'>From Classroom to Boardroom - In 3 steps</article>
          </div>
          <div className="howitworks-carousel d-flex text-center w-100 mt-3">
            <div className="col-14-4">
              <div className='border-0 p-3'>
                <div className='d-flex justify-content-center align-items-center'>
                  <div className='circle-box d-flex justify-content-center align-items-center'>
                    <article className='font-bold fs-1 txt-white'>1</article>
                  </div>
                </div>
                <div className='txt-box mt-4'>
                  <article className='font-medium fs-5'>Enroll Online →</article>
                  <article className='font-medium fs-5'>{'₹ 2,990'} only/- (incl GST)</article>
                </div>
              </div>
            </div>
            <div className="col-14-1">
              <div className='arrow-box'>
                <img src={Right} alt='Arrow Image' />
              </div>
            </div>
            <div className="col-14-4">
              <div className='border-0 p-3'>
                <div className='d-flex justify-content-center align-items-center'>
                  <div className='circle-box d-flex justify-content-center align-items-center'>
                    <article className='font-bold fs-1 txt-white'>2</article>
                  </div>
                </div>
                <div className='txt-box mt-4'>
                  <article className='font-medium fs-5'>Get Trained & Certified → Learn</article>
                  <article className='font-medium fs-5'>entrepreneurship, marketing,</article>
                  <article className='font-medium fs-5'>finance, and more</article>
                </div>
              </div>
            </div>
            <div className="col-14-1">
              <div className='arrow-box'>
                <img src={Right} alt='Arrow Image' />
              </div>
            </div>
            <div className="col-14-4">
              <div className='border-0 p-3'>
                <div className='d-flex justify-content-center align-items-center'>
                  <div className='circle-box d-flex justify-content-center align-items-center'>
                    <article className='font-bold fs-1 txt-white'>3</article>
                  </div>
                </div>
                <div className='txt-box mt-4'>
                  <article className='font-medium fs-5'>Pitch Your Venture → Present</article>
                  <article className='font-medium fs-5'>your ideas to local/national</article>
                  <article className='font-medium fs-5'>stakeholders </article>
                </div>
              </div>
            </div>
          </div>
          <div className='howitworks-btn-box d-flex justify-content-center align-items-center py-5 mb-5'>
            <div className='btn-design bg-red d-flex justify-content-center align-items-center'>
              <p className='mb-0 txt-white font-medium fs-5'>
                {/* <span className='font-bold'>ONE STAGE - </span> */}
                One Stage – Nation’s Best 30 – Where Ideas Meet Industry
              </p>

            </div>
          </div>
        </div>

      </div>
    </section>
  )

}

export default HowItWorks